// Fotos e vídeo da Employer Page na home do hotsite, no padrão da página da empresa v2 (fanpage-v2.js, que é de outra tela): o
// visualizador de fotos em tela cheia (<dialog>) e o player que só carrega no clique.
import { formatar } from './config';
import { desempilhar, empilhar } from './sobreposicao';

const _cliqueComum = e => e.button === 0 && !e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey;

// Setas trocam a foto, Esc fecha (o próprio <dialog>) e o foco volta à foto que abriu. Sem <dialog>, o link abre a foto grande.
export function iniciarFotos(t) {
    const janela = document.getElementById('hs-lbx');
    const fotos = [...document.querySelectorAll('#section-fotos [data-lbx]')];
    if (!janela || !fotos.length || typeof janela.showModal !== 'function') {
        return;
    }
    const imagem = janela.querySelector('[data-lbx-img]');
    const titulo = janela.querySelector('[data-lbx-titulo]');
    janela.querySelectorAll('[data-lbx-ir]').forEach(seta => {
        seta.hidden = fotos.length < 2;
    });
    let atual = 0;
    let origem = null;

    const mostrar = i => {
        atual = (i + fotos.length) % fotos.length;
        imagem.src = fotos[atual].href;
        imagem.alt = formatar(t.fotoAlt, atual + 1, fotos.length);
        titulo.textContent = formatar(t.fotoNDe, atual + 1, fotos.length);
    };

    document.addEventListener('click', e => {
        const foto = e.target.closest('#section-fotos [data-lbx]');
        if (foto) {
            // Ctrl/Cmd + clique: a foto grande em outra aba, como o link.
            if (!_cliqueComum(e)) {
                return;
            }
            e.preventDefault();
            origem = foto;
            mostrar(fotos.indexOf(foto));
            if (!janela.open) {
                janela.showModal();
                // O Voltar do navegador ou do celular fecha as fotos (as setas não entram no histórico).
                empilhar('v2Lbx', () => janela.close());
                janela.querySelector('[data-lbx-fechar]')?.focus();
            }
            return;
        }
        if (!janela.open || !janela.contains(e.target)) {
            return;
        }
        const seta = e.target.closest('[data-lbx-ir]');
        if (seta) {
            mostrar(atual + Number(seta.dataset.lbxIr));
            return;
        }
        // O X e o fundo escuro (fora da foto e dos botões) fecham.
        if (e.target.closest('[data-lbx-fechar]') || !e.target.closest('button, img')) {
            janela.close();
        }
    });
    janela.addEventListener('keydown', e => {
        if (fotos.length < 2 || (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight')) {
            return;
        }
        e.preventDefault();
        mostrar(atual + (e.key === 'ArrowRight' ? 1 : -1));
    });
    janela.addEventListener('close', () => {
        imagem.removeAttribute('src');
        desempilhar('v2Lbx');
        origem?.focus();
    });
}

// O player do YouTube ou do Vimeo só entra depois do clique, no lugar da miniatura.
export function iniciarVideo() {
    document.addEventListener('click', e => {
        const botao = e.target.closest('[data-video]');
        if (!botao) {
            return;
        }
        const endereco = botao.dataset.video;
        const quadro = document.createElement('iframe');
        quadro.className = 'hs-video';
        quadro.src = `${endereco}${endereco.includes('?') ? '&' : '?'}autoplay=1`;
        quadro.title = botao.dataset.titulo || '';
        quadro.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        quadro.allowFullscreen = true;
        botao.replaceWith(quadro);
        quadro.focus();
    });
}
